import React, { useEffect, useState } from 'react';
import './Form.css';
import Button from '../Button/Button.jsx';
import { submitApplicationRequest } from '../../api/requestsApi.js';

async function submitForm(payload) {
    try {
        return await submitApplicationRequest(payload);
    } catch (error) {
        const message =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            'Ошибка отправки';

        throw new Error(message);
    }
}

export default function Form({ requestType = 'Связаться с нами', messagePrefix = '', submitText = 'Связаться с нами', successText = 'Сообщение отправлено', onSuccess }) {
    const [agree, setAgree] = useState(false);
    const [orgName, setOrgName] = useState("");
    const [orgTouched, setOrgTouched] = useState(false);
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [company, setCompany] = useState("");
    const [sending, setSending] = useState(false);
    const [ok, setOk] = useState(false);
    const [err, setErr] = useState("");

    const trimmedEmail = email.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);
    const isButtonDisabled =
        !isValidEmail || !agree || orgName.trim() === "" || sending;
    const buttonText = sending
        ? "Отправка..."
        : ok
            ? successText
            : submitText;

    useEffect(() => {
        if (!ok) return undefined;

        const timer = setTimeout(() => {
            setOk(false);
        }, 5000);

        return () => clearTimeout(timer);
    }, [ok]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isButtonDisabled) return;
        if (company.trim() !== "") return;

        setSending(true);
        setErr("");
        setOk(false);

        try {
            const finalMessage = [messagePrefix.trim(), message.trim()]
                .filter(Boolean)
                .join('\n\n');

            const payload = {
                type: requestType,
                email: trimmedEmail,
                organization: orgName.trim(),
                message: finalMessage,
            };

            await submitForm(payload);

            setOk(true);
            setEmail("");
            setOrgName("");
            setOrgTouched(false);
            setMessage("");
            setAgree(false);
            setCompany("");

            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        } catch (submitError) {
            setErr(submitError?.message || "send failed");
        } finally {
            setSending(false);
        }
    };


    return (
        <div className="form_container">
            {err && <div className="form_status form_status_error">Ошибка: {err}</div>}

            <form onSubmit={handleSubmit} className="form__main">
                <input
                    type="text"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    tabIndex={-1}
                    autoComplete="off"
                    className="form_honeypot"
                    aria-hidden="true"
                />

                <div className="form_field">
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="e-mail"
                        required
                        autoComplete="off"
                        inputMode="email"
                        aria-invalid={!isValidEmail && trimmedEmail !== ""}
                        disabled={sending}
                    />
                </div>

                <div className="form_field">
                    <input
                        type="text"
                        id="organization"
                        name="organization"
                        value={orgName}
                        onChange={(e) => {
                            setOrgName(e.target.value);
                            setOrgTouched(true);
                        }}
                        placeholder="Организация"
                        required
                        autoComplete="off"
                        aria-invalid={orgTouched && orgName.trim() === ""}
                        disabled={sending}
                    />
                </div>

                <div className="form_field">
          <textarea
              id="description"
              name="description"
              placeholder="Расскажите о вашем проекте"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              disabled={sending}
          />
                </div>

                <div className="form_checkbox">
                    <input
                        type="checkbox"
                        name="privacyPolicy"
                        checked={agree}
                        onChange={(e) => setAgree(e.target.checked)}
                        disabled={sending}
                    />
                    <label>
                        Я принимаю <a href="/privacy" rel="noopener noreferrer">Политику в отношении обработки персональных данных</a>
                    </label>
                </div>

                <div className="form_actions">
                    <Button typeButton="submit" disabled={isButtonDisabled}>
                        {buttonText}
                    </Button>
                </div>
            </form>
        </div>
    );
}
